export default {

    state: {
        loginStatus: false,
        userdata: {},
        orders: [],
    },

    getters: {
        getLoginStatus: state => state.loginStatus,

        getUserData: state => state.userdata,

        getOrders: state => state.orders,
    },

    mutations: {
        setLoginStatus(state, status) {
            state.loginStatus = status
        },

        setUserData(state, data) {
            state.userdata = data
        },

        setOrders(state, orders) {
            state.orders = orders
        },

        resetStore(state) {
            state.loginStatus = false
            state.userdata = {}
            state.orders = []
        }
    },
}